// extracted by mini-css-extract-plugin
export default {"main":"SimplePaging_main__tgzYJ"};